import ConfigProvider from 'antd/es/config-provider'
import locale from 'antd/locale/pt_BR'
import { Outlet } from 'react-router-dom'

import { Header } from './Header'

const Root = () => {
  return (
    <ConfigProvider locale={locale}>
      <Header />

      <main className="flex flex-col grow">
        <Outlet />
      </main>
    </ConfigProvider>
  )
}

export default Root
